import { render, staticRenderFns } from "./agenteia-list.vue?vue&type=template&id=51b6a48c"
import script from "./agenteia-list.vue?vue&type=script&lang=js"
export * from "./agenteia-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports